import React, { useEffect, useMemo } from 'react';

const Marquiz = (props) => {
  const { id = '673c39c3c5d75c0026aed988' } = props;

  const settings = useMemo(() => {
    return {
      id:         id,
      buttonText: '«Подобрать дверь за 30 секунд»',
      bgColor:    '#0054dd',
      textColor:  '#ffffff',
      shadow:     'rgba(0, 84, 221, 0.5)',
    };
  }, [id]);

  useEffect(() => {
    const marquizContainer = document.querySelector('.marquiz__container');

    if (marquizContainer) {
      marquizContainer.innerHTML = '';
    }

    if (window.Marquiz) {
      window.Marquiz.add(['Button', settings]);
    } else {
      const handleMarquizLoaded = () => {
        window.Marquiz.add(['Button', settings]);
      };

      document.addEventListener('marquizLoaded', handleMarquizLoaded);

      return () => {
        document.removeEventListener('marquizLoaded', handleMarquizLoaded);
      };
    }
  }, [settings]);

  return (
    <div data-marquiz-id={id}></div>
  );
};

export default Marquiz;